import useSWR from "swr";
import {OffersCountDto} from "../../../services/api";

export const useOfferCounts = (offerId?: number) => {
    const key = `/api/offers/${offerId}/count`;
    const {data, isLoading, error} = useSWR<OffersCountDto, Error>(offerId ? key : null);

    return {
        mutationKey: key,
        data,
        isLoading,
        error
    }
}
